import {
  ActionListDialogPreview,
  ActionListDialogFields,
  ActionListDialogActions,
} from './ActionListDialog';
import {
  AlertDialogActionSchema,
  MessageBoxFormValueSchema,
  FullScreenDialogFormValueSchema,
  ActionListDialogFormValueSchema,
  OpenLinkFormValueSchema,
} from '#/components/ui/messages/model';
import { AlertDialogPreview, AlertDialogFields } from './AlertDialog';

import { MessageBoxPreview, MessageBoxFields } from './MessageBox';
import {
  FullScreenDialogPreview,
  FullScreenDialogFields,
} from './FullScreenDialog';
import { OpenLinkFields } from './OpenLink';

export const ActionVariants = {
  action_list_dialog: {
    key: 'action_list_dialog',
    Preview: ActionListDialogPreview,
    Fields: ActionListDialogFields,
    Actions: ActionListDialogActions,
    Schema: ActionListDialogFormValueSchema,
    name: 'Action list Dialog',
  },
  alert_dialog: {
    key: 'alert_dialog',
    Preview: AlertDialogPreview,
    Fields: AlertDialogFields,
    Actions: null,
    Schema: AlertDialogActionSchema,
    name: 'Alert Dialog',
  },
  full_screen_dialog: {
    key: 'full_screen_dialog',
    Preview: FullScreenDialogPreview,
    Fields: FullScreenDialogFields,
    Actions: null,
    Schema: FullScreenDialogFormValueSchema,
    name: 'Full-screen Dialog',
  },
  message_box: {
    key: 'message_box',
    Preview: MessageBoxPreview,
    Fields: MessageBoxFields,
    Schema: MessageBoxFormValueSchema,
    Actions: null,
    name: 'message_box',
  },
  open_link: {
    key: 'open_link',
    Preview: null,
    Fields: OpenLinkFields,
    Actions: null,
    Schema: OpenLinkFormValueSchema,
    name: '開啟連結',
  },
} as const;
